import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-links-line text-base" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                {t('nav.brand')}
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              {t('footer.disclaimer')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              {t('footer.explore')}
            </h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t('footer.guide')}
                </Link>
              </li>
              <li>
                <Link to="/guides/usfans-buying-guide" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t('nav.shoppingGuide')}
                </Link>
              </li>
              <li>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {t('nav.visitMain')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              {t('footer.company')}
            </h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t('nav.about')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t('nav.contact')}
                </Link>
              </li>
              <li>
                <Link to="/editorial-policy" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t('nav.editorial')}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-sm text-background-200 transition-colors hover:text-background-50">
                  {t('nav.privacy')}
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">
              {t('footer.disclaimerTitle')}
            </h4>
            <p className="mt-4 text-xs leading-relaxed text-background-300">
              {t('footer.disclaimer')}
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} {t('nav.brand')}. {t('footer.rights')}
          </p>
          <p className="text-xs text-background-300">{t('hero.trust')}</p>
        </div>
      </div>
    </footer>
  );
}